import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import {
  FaBuilding,
  FaUsers,
  FaAward,
  FaHardHat,
} from "react-icons/fa";

const HeroCounters = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const stats = [
    {
      icon: <FaBuilding />,
      number: 50,
      suffix: "+",
      title: "Projects Completed",
    },
    {
      icon: <FaUsers />,
      number: 100,
      suffix: "+",
      title: "Happy Clients",
    },
    {
      icon: <FaAward />,
      number: 10,
      suffix: "+",
      title: "Years Experience",
    },
    {
      icon: <FaHardHat />,
      number: 50,
      suffix: "+",
      title: "Expert Team",
    },
  ];

  return (
    <section
      ref={ref}
      className="relative py-12 md:py-24 bg-[#082B57] overflow-hidden"
    >
      {/* Background Decoration */}

      <div className="absolute top-0 left-0 w-full h-full opacity-0 md:opacity-10">
        <div className="absolute top-10 left-10 w-48 h-48 md:w-72 md:h-72 border border-white rounded-full"></div>

        <div className="absolute bottom-0 right-0 w-64 h-64 md:w-96 md:h-96 border border-white rounded-full"></div>
      </div>

      <div className="container-custom relative z-10">

        {/* Heading */}

        <div className="text-center mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Our Achievement
          </span>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mt-4">
            Delivering Excellence
            <span className="text-[#F59E0B]">
              {" "}Every Step Of The Way
            </span>
          </h2>

          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            Our commitment to quality, innovation and customer
            satisfaction has helped us build a strong reputation
            in the construction and real estate industry.
          </p>

        </div>

        {/* Counters */}

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">

          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl p-6 sm:p-8 text-center hover:-translate-y-2 transition-all duration-300"
            >

              <div className="w-20 h-20 mx-auto rounded-2xl bg-[#F59E0B] flex items-center justify-center text-white text-3xl">
                {item.icon}
              </div>

              <h3 className="text-5xl font-bold text-white mt-6">
                {inView && (
                  <CountUp
                    end={item.number}
                    duration={3}
                  />
                )}
                {item.suffix}
              </h3>

              <p className="text-white/70 mt-3 text-lg">
                {item.title}
              </p>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default HeroCounters;